import { createAsyncThunk } from "@reduxjs/toolkit";
import {axios} from '../../common'
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ROLE_USER_SHOW = "roleUser/show";
const ROLE_USER_CREATE = "roleUser/create";

export const showRoleUser = createAsyncThunk(
  ROLE_USER_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}RoleUser`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
            request.headers["MappedState"] = 1;
          },
        }),
        expand: ["User($expand=Employee($expand=Department,Position))"],
        filter: payload.length > 0 ? ["Role/Oid eq " + payload + ""] : [],
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createRoleUser = createAsyncThunk(
  ROLE_USER_CREATE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("RoleUser", payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
